import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, Card, CardActions, Checkbox, CircularProgress, FormControlLabel } from '@mui/material';
import { AppCardSection, AppChoiceList, AppFormLayout, AppSelect } from '@shared';


import TagsInput from 'react-tagsinput';
import OrdersList from 'components/views/orders/components/OrdersList';

const propTypes = {
  queryOrders: PropTypes.func.isRequired,
  orderIds: PropTypes.array.isRequired,

  loading: PropTypes.bool,
  values: PropTypes.shape({
    teamId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  }),

  handleChange: PropTypes.func.isRequired,
  setOrderIds: PropTypes.func.isRequired,

  teamOptions: PropTypes.array.isRequired,
  uberVehicleOptions: PropTypes.array.isRequired,
};

const defaultProps = {

}
const DispatchControlTagForm = ({ values, ...props }) => {
  const [isUber, setIsUber] = useState(false);

  let valueIsValid = !values.teamId;

  useEffect( () => {
    if(!!values.teamId){
      const team = props.teamOptions.find(team => team.value === values.teamId );
      setIsUber(team.data.uber);
    }
  }, [values.teamId])
  
  return(

  <div>
    <Card>
      <AppCardSection title={I18n.t("form.placeholder.dispatch_control.order_ids")}>
        <div className="hidden_i">
          <AppChoiceList
              title={ I18n.t("activerecord.attributes.order.provider_name") }
              choices={[
                {label: 'Bright Pearl', value: 'bright_pearl'},
                {label: 'Shopify', value: 'shopify'},
              ]}
              selected={ [values.providerName] }
              onChange={ (values) => props.handleProviderChange(values[0], "providerName") }
            />
        </div>
        <AppFormLayout>

          <div className="mb8">
            <AppFormLayout>
              <AppFormLayout.Group>
                <AppSelect
                  id="team"
                  name="team"
                  label={I18n.t("activerecord.models.team.one")}
                  options={props.teamOptions}
                  value={ values.teamId }
                  onChange={ (value) => props.handleChange(Number(value), "teamId") }
                  error={props.errors.team}
                />
              </AppFormLayout.Group>
            </AppFormLayout>
          </div>

          { isUber && 
            <AppFormLayout.Group>
              <AppSelect
                id="uber_vehicle"
                name="uber_vehicle"
                label="Tipo de Vehículo Uber"
                options={props.uberVehicleOptions}
                value={ values.uber_vehicle }
                onChange={(value) => props.handleChange(value,"uber_vehicle") }
              />
            </AppFormLayout.Group>
          }

          <AppFormLayout.Group>
            <div>
              <TagsInput
                value={props.orderIds}
                onlyUnique
                addKeys={[188, 9, 13]}
                inputProps={{
                  placeholder: I18n.t("form.placeholder.dispatch_control.order_ids")
                }}
                addOnPaste
                pasteSplit={
                  (data) => {
                    return data.split(',').map(d => d.trim())
                  }}
                onChange={ props.setOrderIds  } />
            </div>
          </AppFormLayout.Group>
          
          <AppFormLayout.Group>
            <FormControlLabel
              label="Editar guías"
              disabled={ props.loading || values.orders.length < 1 }
              control={
                <Checkbox
                  checked={ values.editTracking }
                  onChange={ (event) => props.handleChange(event.target.checked, "editTracking") }
                />
              }
            />
          </AppFormLayout.Group>
        </AppFormLayout>
      </AppCardSection>

      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          disabled={ valueIsValid || props.loading }
          startIcon={ props.loading ? <CircularProgress size={16} color="inherit" /> : null }
          onClick={ props.queryOrders }
        >
          { I18n.t("actions.generate") }
        </Button>
      </CardActions>
    </Card>
  </div>
)};

DispatchControlTagForm.propTypes = propTypes;
DispatchControlTagForm.defaultProps = defaultProps;

export default DispatchControlTagForm;
